/* eslint-disable */
import CardTAG from '../CardTAG'
import { IQuestionComponent } from './types'
import React from 'react'
import { useWatch } from 'react-hook-form'
import Normal from '../CaseInvestigation/CardBody/Body/Normal'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import colors from '../../constants/colors'
import { AppDispatch } from '../../store'
import { findItemByUuid, updateAnswerOption } from '../../store/reports/reportsSlice'
import authSelectors from '../../store/auth/authSelectors'
import utils from '../CaseInvestigation/utils'

const placeholder = 'Answer Here'

const selectStyle = {
  '&.MuiSelect-outlined , .MuiOutlinedInput-input': {
    p: '.8rem',
    marginTop: 0,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.WHITE,
  },
  '&.MuiSelect-root , .MuiSelect-icon': {
    top: 'auto !important',
    right: '1.2rem',
    fill: colors.TAG_LINES_GRAY,
  },
  minWidth: '20rem',
  width: '100%',
  height: '100%',
  borderRadius: 0,
  justifyContent: 'center',
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}

const SingleSelectQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  parent,
  previewOnly = false,
}) => {
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = getAnswer()
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()

  
  const resolveBody = () => {
    if (answer && answer?.options && answer?.options?.length && questionObj?.subquestions && questionObj?.subquestions?.length) {
      const subquestions = questionObj?.subquestions.filter((subquestion: any) => subquestion?.option === answer?.options[0])
      if (subquestions) {
        return subquestions?.map((subquestion : any)  =>
          utils.questionParser(
              subquestion,
              control,
              unregister,
              setValue,
              setAnswersFiles,
              answers,
              answer,
              previewOnly
          )
        )
      }
    }

    return null
  }

  const renderSelectOptions = () => {
    
    return questionOptions?.map((selectOption: { text: string; id: number }, index: any) => {
      return (
        <MenuItem value={selectOption.id} key={`${selectOption.text}-${index}`}>
          <Typography variant='h4'>{selectOption.text}</Typography>
        </MenuItem>
      )
    })
  }
  const onChangeHandler = (event: SelectChangeEvent) => {
    dispatch(
      updateAnswerOption({
        answerUUID: answer?.uuid,
        answerText: [event.target.value as unknown as number],
        parentUUID: parent?.uuid
      }),
    )
  }

  const resolveSelectedValueRender = () => {
    const option = questionOptions?.find(option => option.id === answer?.options[0])
    if (option) {
      return option.text && option?.text !== ''
        ? undefined
        : () => (
            <Typography variant='h4' color={colors.TAG_TEXT_GRAY}>
              {placeholder}
            </Typography>
          )
    }
    return () => (
      <Typography variant='h4' color={colors.TAG_TEXT_GRAY}>
        {placeholder}
      </Typography>
    )
  }

  const getValue = () => {
    const option = questionOptions?.find(option => option.id === answer?.options[0])
    return `${option?.id ?? ''}`
  }

  const resolveDisabledButton = () => {
    return previewOnly || !userEditAccess
  }

  return (
    <>
      <div id={`${questionId}`}>
        <CardTAG
          questionCard={true}
          color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
          title={
            <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
              <Typography
                variant='h4'
                sx={{
                  wordWrap: 'break-word',
                  overflow: 'hidden',
                }}
              >
                {question}
              </Typography>
            </Box>
          }
          cardAction={
            <Box sx={{ ma: 0, minWidth: '150px', width: '100%', height: '100%' }}>
              <Select
                onChange={onChangeHandler}
                IconComponent={ArrowIcon}
                displayEmpty
                renderValue={resolveSelectedValueRender()}
                value={getValue()}
                sx={[selectStyle]}
                disabled={resolveDisabledButton()}
              >
                {renderSelectOptions()}
              </Select>
            </Box>
          }
        >
        </CardTAG>
      </div>
      {resolveBody()}
    </>
  )
}

export default SingleSelectQuestionComponent
